import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import { getIndividualByUserId } from "marketplace/individuals/_stores/individuals-redux-slice";
import { useSelector } from "react-redux";
import { MaskedTeam } from "work/_shared/masked-fields";
import WorkAgreement, { WorkAgreementFieldCategory } from "work/work-agreements/work-agreement";

const ProposalContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "1fr",
  },
  display: "grid",
  gap: theme.spacing(6),
  gridTemplateColumns: "auto auto",
  width: "100%",
}));
const GeneralSection = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));
const DateSection = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  "& .MuiFormControl-root": {
    marginTop: theme.spacing(1),
  },
}));
const ClientTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    minWidth: "unset",
    width: "100%",
  },
  margin: theme.spacing(1, 0),
  minWidth: theme.spacing(50),
}));
const NameTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    minWidth: "unset",
    width: "100%",
  },
  margin: theme.spacing(1, 0),
  minWidth: theme.spacing(50),
}));
const DescriptionTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    minWidth: "unset",
    width: "100%",
  },
  margin: theme.spacing(1, 0),
  minWidth: theme.spacing(50),
}));
const DateContainer = styled("div")(({ theme }) => ({
  display: "flex",
  margin: theme.spacing(1, 0),
  width: "100%",
}));

type DetailsTabProps = {
  activeTab: WorkAgreementFieldCategory;
  workAgreement: WorkAgreement;
};

export default function DetailsTab(props: Readonly<DetailsTabProps>) {
  const { activeTab, workAgreement } = props;

  const clientIndividual = useSelector(
    getIndividualByUserId(
      MaskedTeam.isNotMasked(workAgreement.clientTeam) ? workAgreement.clientTeam?.leader?.userId : undefined
    )
  );

  if (activeTab !== WorkAgreementFieldCategory.Details) return null;

  return (
    <ProposalContainer>
      <GeneralSection>
        <ClientTextField
          disabled={true}
          label={clientIndividual?.fullName ? "Client Representative" : "Select Client Representative"}
          error={false}
          value={clientIndividual?.fullName}
        />
        <NameTextField label="Proposal Name" disabled={true} value={workAgreement.name?.value ?? ""} error={false} />
        <DescriptionTextField
          label="Description"
          multiline={true}
          rows={3}
          disabled={true}
          value={workAgreement.description?.value ?? ""}
          error={false}
        />
      </GeneralSection>
      <DateSection>
        <DateContainer>
          <TextField disabled={true} value={workAgreement.startDate?.format("MM/DD/YY") ?? "None"} label="Start Date" />
        </DateContainer>
        <DateContainer>
          <TextField disabled={true} value={workAgreement.endDate?.format("MM/DD/YY") ?? "None"} label="End Date" />
        </DateContainer>
      </DateSection>
    </ProposalContainer>
  );
}
